import { Quantity } from '@ngg/components';

export default function ProductCartSkeleton() {
  return (
    <div className="col-span-full grid w-full animate-pulse grid-cols-[min-content_1fr] gap-2">
      <Quantity
        value={1}
        readOnly
        classNames={{
          wrapper: 'border-0 h-10 bg-transparent',
          input:
            'bg-transparent bold border-gray-150 border-y text-base font-bold min-w-0 w-10 basis-10 -outline-offset-2 action-focus rounded-none',
          decreaseButton:
            'bg-transparent action-focus color-black border-gray-150 border -outline-offset-2 w-10 basis-10 flex justify-center items-center',
          increaseButton:
            'bg-transparent action-focus border-gray-150 border -outline-offset-2 w-10 basis-10 flex justify-center items-center',
        }}
      />
      <div className="h-10 w-full border bg-black/25" />
    </div>
  );
}
